"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upcyclingPricingInverse = exports.upcyclingPricing = exports.pricingInverse = exports.metadata = exports.leatherGoodsPricingInverse = exports.leatherGoodsPricing = exports["default"] = exports.clothPricingInverse = exports.addRoundedTVAPrices = void 0;
var _pricings = _interopRequireWildcard(require("../v9/pricings"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Prices with TVA as opaque mode (+14%) for Belgium
var metadata = exports.metadata = _objectSpread(_objectSpread({}, _pricings.metadata), {}, {
  minOrderAmount: 0,
  deliveryFee: 6,
  version: 10,
  tvaExcessRatio: 1.14,
  commissionRatio: 0.2632,
  // = 30 / 114
  country: 'BE'
});
var updateIdToV10 = function updateIdToV10(clothes) {
  return clothes.map(function (cloth) {
    return _objectSpread(_objectSpread({}, cloth), {}, {
      categories: cloth.categories.map(function (category) {
        return _objectSpread(_objectSpread({}, category), {}, {
          items: category.items.filter(function (_ref) {
            var ref = _ref.ref;
            return !ref;
          }).map(function (item) {
            var id = item.id;
            return _objectSpread(_objectSpread({}, item), {}, {
              id: id === null || id === void 0 ? void 0 : id.replace('9.', '10.')
            });
          })
        });
      })
    });
  });
};
var addRoundedTVAPrices = exports.addRoundedTVAPrices = function addRoundedTVAPrices(clothes) {
  return clothes.map(function (cloth) {
    return _objectSpread(_objectSpread({}, cloth), {}, {
      categories: cloth.categories.map(function (category) {
        return _objectSpread(_objectSpread({}, category), {}, {
          items: category.items.map(function (item) {
            var prices = item.prices,
              liningPrices = item.liningPrices;
            var newPrices = {};
            var newLiningPrices;
            Object.entries(prices).forEach(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                value = _ref3[1];
              if (typeof value === 'number') {
                newPrices[key] = Math.ceil(value * metadata.tvaExcessRatio);
              } else {
                newPrices[key] = {
                  min: Math.ceil(value.min * metadata.tvaExcessRatio),
                  max: Math.ceil(value.max * metadata.tvaExcessRatio)
                };
              }
            });
            if (liningPrices) {
              newLiningPrices = {};
              Object.entries(liningPrices).forEach(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                  key = _ref5[0],
                  value = _ref5[1];
                newLiningPrices[key] = Math.ceil(value * metadata.tvaExcessRatio);
              });
            }
            return _objectSpread(_objectSpread({}, item), {}, {
              prices: newPrices,
              liningPrices: newLiningPrices
            });
          })
        });
      })
    });
  });
};
var pricing = addRoundedTVAPrices(updateIdToV10(_pricings["default"]));
var upcyclingPricing = exports.upcyclingPricing = addRoundedTVAPrices(updateIdToV10(_pricings.upcyclingPricing));
var leatherGoodsPricing = exports.leatherGoodsPricing = addRoundedTVAPrices(updateIdToV10(_pricings.leatherGoodsPricing));
var _default = exports["default"] = pricing;
var clothPricingInverse = exports.clothPricingInverse = (0, _pricings.enrichWithPricingInverse)(pricing);
var upcyclingPricingInverse = exports.upcyclingPricingInverse = (0, _pricings.getUpcyclingInverse)(upcyclingPricing);
var leatherGoodsPricingInverse = exports.leatherGoodsPricingInverse = (0, _pricings.enrichWithPricingInverse)(leatherGoodsPricing);
var pricingInverse = exports.pricingInverse = _objectSpread(_objectSpread(_objectSpread({}, clothPricingInverse), upcyclingPricingInverse), leatherGoodsPricingInverse);